// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "4b1e1488dc09cb9e","396": "83c5cb2b589dd66d","460": "844a1ebd29341ec2","917": "d0ee74d3cc41927a","985": "af2f63f0e341c3c9",}[chunkId] + ".chunk.js"
}